'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Header = require('./components/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Body = require('./components/Body');

var _Body2 = _interopRequireDefault(_Body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RpSimpleTable = function (_PureComponent) {
  _inherits(RpSimpleTable, _PureComponent);

  function RpSimpleTable() {
    _classCallCheck(this, RpSimpleTable);

    return _possibleConstructorReturn(this, (RpSimpleTable.__proto__ || Object.getPrototypeOf(RpSimpleTable)).apply(this, arguments));
  }

  _createClass(RpSimpleTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          columns = _props.columns,
          loading = _props.loading,
          noDataText = _props.noDataText,
          className = _props.className,
          uiType = _props.uiType,
          sortIdx = _props.sortIdx,
          onHeaderCellClick = _props.onHeaderCellClick;


      var sortable = data.length > 0;

      var tableClassName = (0, _classnames2.default)('ui-table', className, 'ui-table_type' + uiType, sortable && 'ui-table_sortable');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          { className: tableClassName },
          _react2.default.createElement(_Header2.default, {
            columns: columns,
            sortable: data.length > 0,
            sortIdx: sortIdx,
            onHeaderCellClick: onHeaderCellClick
          }),
          _react2.default.createElement(_Body2.default, {
            data: data,
            columns: columns,
            loading: loading,
            noDataText: noDataText
          })
        )
      );
    }
  }]);

  return RpSimpleTable;
}(_react.PureComponent);

RpSimpleTable.defaultProps = {
  data: [],
  uiType: 1,
  noDataText: 'No data for this table'
};

RpSimpleTable.propTypes = {
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    cell: _propTypes2.default.func,
    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    className: _propTypes2.default.string
  })).isRequired,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  sortIdx: _propTypes2.default.number,
  className: _propTypes2.default.string,
  uiType: _propTypes2.default.number,
  noDataText: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onHeaderCellClick: _propTypes2.default.func.isRequired
};

exports.default = RpSimpleTable;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/RpSimpleTable.js
// module id = 2782
// module chunks = 0